import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { popInOut } from '../../../../common/animations';
import { CompanyWithOffer } from '../../../../common/models/company/company-with-offer';

@Component({
  selector: 'psc-company-table',
  standalone: true,
  imports: [CommonModule, TranslocoModule, MatIconModule, MatTooltipModule],
  templateUrl: './company-table.component.html',
  animations: [popInOut],
})
export class CompanyTableComponent {
  @Input() companies: CompanyWithOffer[] = [];
  @Input() currency: string;
  @Output() deleteCompanyClicked: EventEmitter<CompanyWithOffer> = new EventEmitter<CompanyWithOffer>();

  deleteEntryClicked(company: CompanyWithOffer) {
    this.deleteCompanyClicked.emit(company);
  }
}
